<ct-lib-dashboard-card
  [title]="'jobboard.platform.dashboard.profile-completeness.title' | transloco"
  [icon]="icons.listCheck"
>
  <p class="description">
    {{ 'jobboard.platform.dashboard.profile-completeness.description' | transloco }}
  </p>

  <ct-lib-progress-bar [value]="progressPercent()"></ct-lib-progress-bar>
  <p class="progress-label">
    {{
      'jobboard.platform.dashboard.profile-completeness.progress'
        | transloco: { percent: progressPercent() }
    }}
  </p>

  <ul class="step-list" role="list">
    @for (step of steps(); track step.titleKey) {
      <li>
        <button
          type="button"
          class="step-item"
          [class.completed]="step.completed"
          (click)="openProfile(step.fragment)"
        >
          <span class="step-indicator" aria-hidden="true">
            <fa-icon
              [icon]="step.completed ? icons.checkCircle : icons.circle"
            ></fa-icon>
          </span>
          <span class="step-content">
            <b class="step-title">{{ step.titleKey | transloco }}</b>
            <span class="step-description text-muted">{{
              step.descriptionKey | transloco
            }}</span>
          </span>
          <span class="step-chevron" aria-hidden="true">
            <fa-icon [icon]="icons.chevronRight"></fa-icon>
          </span>
        </button>
      </li>
    }
  </ul>
</ct-lib-dashboard-card>
